import * as t from 'io-ts';

import {makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime type.
 */

export enum MessageErrorSourcesEnum {
  SERVER = 'SERVER',
  CLIENT = 'CLIENT',
}

export enum MessageErrorsEnum {
  CANT_SAVE = 'CANT_SAVE',
  SMTP_BAD_CONTENT = 'SMTP_BAD_CONTENT',
  SMTP_CONNECTION_CLOSED = 'SMTP_CONNECTION_CLOSED',
  SMTP_CONNECTION_REFUSED = 'SMTP_CONNECTION_REFUSED',
  SMTP_CONNECTION_RESET = 'SMTP_CONNECTION_RESET',
  SMTP_GREETING = 'SMTP_GREETING',
  UNKNOWN = 'UNKNOWN',
  VERSION_CONFLICT = 'VERSION_CONFLICT',
  PHISHING = 'PHISHING',
}

export enum MessageSecurityErrorsEnum {
  BLACKLISTED_DOMAIN = 'blacklisted_domain',
  ID_USURPATION = 'id_usurpation',
  WEB_RISK_MATCH = 'web_risk_match',
}

const RMessageErrorDirty = t.readonly(
  t.intersection([
    t.type({
      source: makeEnumRuntimeType(MessageErrorSourcesEnum),
      type: makeEnumRuntimeType(MessageErrorsEnum),
    }),
    t.partial({
      description: t.string,
    }),
  ]),
);

const RMessageSecurityErrorDirty = t.intersection([
  RMessageErrorDirty,
  t.partial({
    reason: makeEnumRuntimeType(MessageSecurityErrorsEnum),
  }),
]);

/*
 * Type.
 */

export interface MessageErrorModel extends t.TypeOf<typeof RMessageErrorDirty> {}
export interface MessageSecurityErrorModel extends t.TypeOf<typeof RMessageSecurityErrorDirty> {}

export const RMessageError = t.clean<MessageErrorModel>(RMessageErrorDirty as any);
export const RMessageSecurityError = t.clean<MessageSecurityErrorModel>(RMessageSecurityErrorDirty as any);

/*
 * IO methods.
 */

export function parseMessageError(src: any): MessageErrorModel {
  return {
    source: MessageErrorSourcesEnum.SERVER,
    type: parseMessageErrorType(src.error_type),
    description: src.error_desc || undefined,
  };
}

function parseMessageErrorType(src: any): MessageErrorsEnum {
  switch (src) {
    case 'smtp_bad_content':
    case 'illegal_content':
      return MessageErrorsEnum.SMTP_BAD_CONTENT;

    case 'smtp_conn_closed':
      return MessageErrorsEnum.SMTP_CONNECTION_CLOSED;

    case 'smtp_conn_refused':
      return MessageErrorsEnum.SMTP_CONNECTION_REFUSED;

    case 'smtp_conn_reset':
      return MessageErrorsEnum.SMTP_CONNECTION_RESET;

    case 'smtp_greeting':
    case 'greeting_never_received':
      return MessageErrorsEnum.SMTP_GREETING;

    case 'phishing':
      return MessageErrorsEnum.PHISHING;

    default:
      return MessageErrorsEnum.UNKNOWN;
  }
}

export function parseSecurityError(src: any): MessageSecurityErrorModel {
  const type = parseMessageErrorType(src.security_error);
  const json = {
    source: MessageErrorSourcesEnum.SERVER,
    type,
  };

  if (type === MessageErrorsEnum.PHISHING && src.security_violation && src.security_violation.length > 0) {
    const securityViolation = src.security_violation[0];
    return {
      ...json,
      description: securityViolation.description,
      reason: securityViolation.reason,
    };
  }

  return json;
}
